import React from 'react';
import { SEO, Banner } from '../common';
import Author from '../blog/Author';

interface VideoPosterProps {
  post: any;
}

export default function VideoPoster({ post = {} }: VideoPosterProps) {
  return (
    <>
      <SEO title={post.title} description={post.resumen} />
      <Banner text="Poster" />
      <div className="flex flex-col flex-wrap py-16">
        <article
          className="max-w-full lg:max-w-5xl px-4 mx-auto"
          itemScope
          itemType="http://schema.org/Article"
        >
          <header className="flex flex-col">
            <h1
              itemProp="headline"
              className="text-center font-bold text-4xl mb-4"
            >
              {post?.title?.split('\\n')?.map((text) => (
                <React.Fragment key={text}>
                  {String(text)?.replace('\\n', '')?.trim()}
                  <br />
                </React.Fragment>
              ))}
            </h1>
            <div className="flex flex-col max-w-xl mx-auto">
              {post?.authors?.map((author, idx) => (
                <Author author={author} idx={idx + 1} key={idx} />
              ))}
            </div>
            <h3 className="text-base mb-2 mx-auto">
              Palabras Clave:{' '}
              <span className="text-sm">{post?.keywords?.join(', ')}</span>
            </h3>
            <div className="flex flex-row flex-wrap space-x-2 justify-center">
              {/*  */}
            </div>
          </header>
          <div
            dangerouslySetInnerHTML={{ __html: post.resumen }}
            className="prose text-justify my-4 mx-auto"
            itemProp="articleBody"
          />
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube-nocookie.com/embed/${post.youtube}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="mx-auto my-8"
          />
          <hr />
        </article>
      </div>
    </>
  );
}
